import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

const OrderList = ({ orders, onSelect }) => {
  return (
    <List>
      <ListItem
        style={{
          borderBottom: '1px solid #a1a1a1',
          backgroundColor: '#000',
          color: '#fff',
        }}
      >
        <ListItemIcon>
          <ListItemText
            primary={
              <Typography
                variant="h6"
                style={{ width: 200, color: '#fff', fontSize: 14 }}
              >
                PO
              </Typography>
            }
          />
        </ListItemIcon>

        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Submission Date
          </Typography>
        </ListItemIcon>
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Expected Shipped Date
          </Typography>
        </ListItemIcon>
        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Expected In-hand Date
          </Typography>
        </ListItemIcon>

        <ListItemIcon>
          <Typography
            style={{ width: 200, color: '#fff', fontSize: 14 }}
            variant="h6"
          >
            Ship Account
          </Typography>
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography variant="h6" style={{ color: '#fff', fontSize: 14 }}>
              Total Quantity
            </Typography>
          }
        />
        <ListItemSecondaryAction style={{ color: '#fff' }}>
          <Typography
            style={{
              width: 200,
              color: '#fff',
              textAlign: 'right',
              fontSize: 14,
            }}
            variant="h6"
          >
            Status
          </Typography>
        </ListItemSecondaryAction>
      </ListItem>
      {orders.map((value) => {
        const orderPO = value?.orderPO[0];

        return (
          <ListItem
            key={orderPO}
            role={undefined}
            dense
            button
            style={{ borderBottom: '1px solid #a1a1a1' }}
            onClick={() => onSelect(value)}
          >
            <ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    style={{ width: 200, color: '#000', fontSize: 14 }}
                  >
                    {orderPO}
                  </Typography>
                }
              />
            </ListItemIcon>

            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value.submissionDate}
              </Typography>
            </ListItemIcon>
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.expectedShipDate &&
                value?.expectedShipDate[0] !== 'Invalid date'
                  ? moment(value?.expectedShipDate[0]).format('MMM-DD-YYYY')
                  : null}
              </Typography>
            </ListItemIcon>
            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.expectedInhandDate &&
                value?.expectedInhandDate[0] !== 'Invalid date'
                  ? moment(value?.expectedInhandDate[0]).format('MMM-DD-YYYY')
                  : null}
              </Typography>
            </ListItemIcon>

            <ListItemIcon>
              <Typography
                style={{ width: 200, color: '#000', fontSize: 14 }}
                variant="h6"
              >
                {value?.shippingAccount ? value?.shippingAccount : null}
              </Typography>
            </ListItemIcon>

            <ListItemText
              primary={
                <Typography
                  variant="h6"
                  style={{ width: 200, color: '#000', fontSize: 14 }}
                >
                  0
                </Typography>
              }
            />
            <ListItemSecondaryAction>
              <Typography
                style={{
                  width: 200,
                  color: '#000',
                  textAlign: 'right',
                  fontSize: 14,
                }}
                variant="h6"
              >
                {value.status}
              </Typography>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default OrderList;
